import React, { useEffect, useState } from 'react';
import { View, Text } from 'react-native';
import InputDefault from "../../components/Form/InputDefault";
import RNPickerSelect from "react-native-picker-select";
import { FormattedMessage, useIntl } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import { toast } from '../../utils/toast';
import api from '../../services/api';

import styles from './styles';

const BankAccountPix = () => {
    const [bank, setBank] = useState(0);
    const [typeAccount, setTypeAccount] = useState(0);
    const [agency, setAgency] = useState('');
    const [account, setAccount] = useState('');
    const [itemsBanks, setItemsBanks] = useState([]);
    const [accountType, setAccountType] = useState([]);

    useEffect(() => {
        getBanks();
        getAccountType();
    }, []);

    function getBanks() {
        api.get('/banks')
            .then((res) => {
                var banks = [];

                res.data.data.map(item => {
                    banks.push({
                        'label': item.bank,
                        'value': item.id
                    })
                })

                setItemsBanks(banks);
            })
            .catch((error) => {
                const intl = useIntl();
                toast(intl.formatMessage({id:'bankAccountPix.erroCarregaDados'}), "#DA1414");
            })
    }

    function getAccountType() {
        api.get('/bank-account-types')
            .then((res) => {
                var types = [];

                res.data.data.map(item => {
                    types.push({
                        'label': item.name,
                        'value': item.id
                    })
                })

                setAccountType(types);
            })
            .catch((error) => {
                const intl = useIntl();
                toast(intl.formatMessage({id:'bankAccountPix.erroCarregaDados'}));
            })
    }

    return (
        <>
            <HeaderDefault title={<FormattedMessage id='bankAccountPix.headerAgencia&Conta'/>} />
            <View style={styles.container}>
                <View style={styles.contentInput}>
                    <RNPickerSelect
                        onValueChange={(value) => setBank(value)}
                        placeholder={{
                            label: <FormattedMessage id='bankAccountPix.selecioneBanco'/>,
                            value: 0,
                        }}
                        items={itemsBanks}
                        value={bank}
                        style={{
                            inputWeb: {
                                borderRadius: 4,
                                paddingHorizontal: 10,
                                height: 40,
                                marginVertical: 10,
                                color: '#222'
                            }
                        }} />

                    <RNPickerSelect
                        onValueChange={(value) => setTypeAccount(value)}
                        placeholder={{
                            label: <FormattedMessage id='bankAccountPix.selecioneTipoConta'/>,
                            value: 0,
                        }}
                        items={accountType}
                        value={typeAccount}
                        style={{
                            inputWeb: {
                                borderRadius: 4,
                                paddingHorizontal: 10,
                                height: 40,
                                marginVertical: 10,
                                color: '#222'
                            }
                        }}
                    />

                    <FormattedMessage id='bankAccountPix.placeholderAgencia'>
                        {placeholde =>
                    <InputDefault
                        value={agency}
                        onValueChange={(value) => setAgency(value)}
                        placeholder={placeholder}
                        type={"numeric"}
                    />}
                    </FormattedMessage>

                    <FormattedMessage id='bankAccountPix.placeholderNumeroConta'>
                        {placeholder =>
                    <InputDefault
                        value={account}
                        onValueChange={(value) => setAccount(value)}
                        placeholder={placeholder}
                        type={"numeric"}
                    />}
                    </FormattedMessage>
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='bankAccountPix.txtValorTransferencia'/></Text>
                    <Text><FormattedMessage id='bankAccountPix.txtValorTransferenciaBrl'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='bankAccountPix.txtMoeda'/></Text>
                    <Text><FormattedMessage id='bankAccountPix.txtGpxToken'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='bankAccountPix.txtValorDoDia'/></Text>
                    <Text><FormattedMessage id='bankAccountPix.txtValorDoDiaGpx'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='bankAccountPix.txtRecebedor'/></Text>
                    <Text><FormattedMessage id='bankAccountPix.txtNome'/></Text>
                </View>
            </View>

            <Text style={styles.transferValueInfo}><FormattedMessage id='bankAccountPix.txtValorDaTransacao'/></Text>
            <Button route={"ConfirmPassword"} text={<FormattedMessage id='bankAccountPix.btnContinuar'/>} titlePage={<FormattedMessage id='bankAccountPix.btnContinuarTransferencia'/>} />
        </>
    );
}

export default BankAccountPix;